import script from "./CDSDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CDSDialog.vue?vue&type=script&setup=true&lang=ts"

import "./CDSDialog.vue?vue&type=style&index=0&id=caac7076&lang=css"

const __exports__ = script;

export default __exports__